var EHDI = EHDI || Object.create(null);
var UTILS = UTILS || Object.create(null);
var POOLS = POOLS || Object.create(null);

EHDI.components = EHDI.components || Object.create(null);

EHDI.components.BonusDisplay = function() {    
    EHDI.aka.Container.call(this);

    var COMPLETION_TIME = 450;
    var DELAY_TIME = 1500;

  
   
    this.completionTimer=0;
    this.delayTimer=0;
    this.active = false;
    this.scaleSpeed = 4;

    this.label= new EHDI.aka.Sprite(EHDI.Assets.images["fx_megabonus"]);
    this.label.anchor.set(0.5, 0);
    this.label.scale.set(0, 0);
    this.addChild(this.label);
    this.label.x = 153.6;
    this.label.y = 50;


    this.appear = function(score)
    {
        if(this.active)
            return;

        this.active = true;
        this.completionTimer=COMPLETION_TIME;
        this.delayTimer=DELAY_TIME;
    }

    this.disappear = function()
    {
        if(!this.active)
            return;

        this.active = false;

    }

    this.update = function (delta)
    {
        if(!this.active)
            return false;

        this.completionTimer -= delta;

        if(this.completionTimer <= 0)
        {
            this.delayTimer -=delta;
            if(this.delayTimer <= 0)
            {   
                this.disappear();
                return true;
            }
        }
        else
        {
            this.label.scale.x += delta / 1000 * this.scaleSpeed;
            this.label.scale.y += delta / 1000 * this.scaleSpeed;
            this.label.scale.x = Math.min(this.label.scale.x, 1);
            this.label.scale.y = Math.min(this.label.scale.y, 1);
        }

        return false; 
    }
}
EHDI.components.BonusDisplay.prototype = Object.create(EHDI.aka.Container.prototype);
